import { isEmpty } from "lodash";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { backendApis } from "../config";
import { searchParamsToObject } from "../utils/helpers";
import ModalLoader from "./utils/ModalLoader";
import { LoaderIcon } from "./Icons";

function getQueryParams() {
  const url = new URL(document.location.href);
  return searchParamsToObject(url.searchParams.entries());
}

async function fetchAuthUser(backendUrl) {
  const response = await fetch(`${backendUrl}/api/users/token/get-auth-user`, {
    method: "GET",
    headers: {
      Accept: "Application/json",
      "Content-Type": "Application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(
      "Unable to verify account, check your connection and refresh the page"
    );
  }

  const data = await response.json();
  if (isEmpty(data.email)) {
    throw new Error("User not found in company");
  }

  return data;
}

export default function AuthorizeCompanyStaffRoute() {
  const queryParams = getQueryParams();
  const params = useParams();

  const { company } = { ...queryParams, ...params };
  const backendApi = backendApis.find(el => el.name === company);

  const isParamsValid = !!backendApi;

  const { data: authUser, isLoading, isError, isSuccess } = useQuery(
    ["auth-staff", company],
    () => fetchAuthUser(backendApi.url),
    {
      enabled: isParamsValid,
      retry: false,
      onError: err => toast.error(err.message),
    }
  );

  if (isLoading) {
    return (
      <div className="global-spinner">
        <LoaderIcon className="spin text-primary" />
      </div>
    );
  }

  if (isError || !isParamsValid || !authUser) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}
